import gql from 'graphql-tag'

export default gql`
mutation createSiteConfig(
    $domain: String!
    $siteId: String!
    $siteServices: [SiteServiceInput!]!
    $enabled: Boolean
    $channelPartner: String
    $companyName: String
  
  ){
    createSiteConfig(input:{
      domain: $domain
      siteId: $siteId
      enabled: $enabled
      siteServices: $siteServices
      channelPartner: $channelPartner
      companyName: $companyName
    }){
      domain
    }
  }`
  